import { Box, Flex, Image, Text, useMediaQuery } from "@chakra-ui/react";
import theme from "./assets/Theme";
import emertechLogo from "./assets/images/Emertech_Logo.png";

function TraceApp({ children }) {
  const [isDesktop] = useMediaQuery("(min-width: 768px)");
  return (
    <Box>
      <Flex
        theme={theme}
        justifyContent="center"
        alignItems="center"
        height={{ base: "100vh", md: "100%" }}
        width={{ base: "100%", md: "100%", lg: "480px" }}
        // marginX={{ md: "auto" }}
        // paddingX={{ base: "1rem", md: "0" }}
      >
        {children}
      </Flex>
      <Flex
        marginTop={"2rem"}
        marginBottom={"1rem"}
        justifyContent="center"
        alignItems={"center"}
        flexDirection="column"
      >
        <Box>
          <Text color={"#141D43"} fontSize="xs" fontWeight={"500"}>
            Powered by
          </Text>
        </Box>
        <a
          target={"_blank"}
          rel="noreferrer noopener"
          href="https://emertech.io/"
        >
          <Image src={emertechLogo} width="80px" />
        </a>
      </Flex>
    </Box>
  );
}

export default TraceApp;
